export const HttpCodes = {
  FOUND: 302,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  BAD_REQUEST: 400,
  CONFLICT: 409,
  INTERNAL_ERROR: 500,
  PRE_CONDITION_FAILED: 412,
  OK: 200,
};

export const joinQuestions = {
  study: 1,
  welcome: 2,
  eligibility: 3,
  agreement: {
    read: 4,
    confirm: 5,
  },
  registration: {
    age: 6,
    personal: 7,
    contact: 8,
    physician: 9,
    confirm: 10,
  },
  success: 11,
  refused: 12,
};

export const SimpleQuestion = {
  notReplied: -1,
  no: 0,
  yes: 1,
};

export const trials = {
  notReplied: {
    label: "",
    value: 0,
  },
  xlh: {
    label: "XLH",
    value: 1,
  },
  angelman: {
    label: "Angelman study",
    value: 2,
  },
  lcfaod: {
    label: "LC-FAOD",
    value: 3,
  },
  wilson: {
    label: "Wilson's Disease",
    value: 4,
  },
  glycogen: {
    label: "Glycogen Storage Disorder",
    value: 5,
  },
  tio: {
    label: "TIO",
    value: 6,
  },
  mpsvii: {
    label: "MPS VII",
    value: 7,
  },
  rarify: {
    label: "Rarify Community",
    value: 8,
  },
  otc: {
    label: "Ornithine Transcarbamylase (OTC) Deficiency",
    value: 9,
  },
};

export const ageAnswer = {
  notReplied: {
    label: "Select",
    value: 0,
  },
  registrationAdultPlus18: {
    label: "An adult (age 18+) with the disorder",
    value: 1,
  },
  legalGuardianOfAdultPlus18: {
    label: "A legal guardian of an adult (age 18+) with the disorder",
    value: 2,
  },
  legalGuardianOfChild0to4: {
    label: "A legal guardian of a child (ages 0-4) with the disorder",
    value: 3,
  },
  legalGuardianOfChild5to11: {
    label: "A legal guardian of a child (ages 5-11) with the disorder",
    value: 4,
  },
  legalGuardianOfTeenage12to17: {
    label: "A legal guardian of an adolescent (ages 12-17) with the disorder",
    value: 5,
  },
};

export const joinStudyState = {
  notReplied: {
    label: "",
    value: 0,
  },
  us: {
    label: "United States",
    values: {
      US_AL: {
        label: "AL",
        value: 1,
      },
      US_AK: {
        label: "AK",
        value: 2,
      },
      US_AZ: {
        label: "AZ",
        value: 3,
      },
      US_AR: {
        label: "AR",
        value: 4,
      },
      US_CA: {
        label: "CA",
        value: 5,
      },
      US_CO: {
        label: "CO",
        value: 6,
      },
      US_CT: {
        label: "CT",
        value: 7,
      },
      US_DE: {
        label: "DE",
        value: 8,
      },
      US_FL: {
        label: "FL",
        value: 9,
      },
      US_GA: {
        label: "GA",
        value: 10,
      },
      US_HI: {
        label: "HI",
        value: 11,
      },
      US_ID: {
        label: "ID",
        value: 12,
      },
      US_IL: {
        label: "IL",
        value: 13,
      },
      US_IN: {
        label: "IN",
        value: 14,
      },
      US_IA: {
        label: "IA",
        value: 15,
      },
      US_KS: {
        label: "KS",
        value: 16,
      },
      US_KY: {
        label: "KY",
        value: 17,
      },
      US_LA: {
        label: "LA",
        value: 18,
      },
      US_ME: {
        label: "ME",
        value: 19,
      },
      US_MD: {
        label: "MD",
        value: 20,
      },
      US_MA: {
        label: "MA",
        value: 21,
      },
      US_MI: {
        label: "MI",
        value: 22,
      },
      US_MN: {
        label: "MN",
        value: 23,
      },
      US_MS: {
        label: "MS",
        value: 24,
      },
      US_MO: {
        label: "MO",
        value: 25,
      },
      US_MT: {
        label: "MT",
        value: 26,
      },
      US_NE: {
        label: "NE",
        value: 27,
      },
      US_NV: {
        label: "NV",
        value: 28,
      },
      US_NH: {
        label: "NH",
        value: 29,
      },
      US_NJ: {
        label: "NJ",
        value: 30,
      },
      US_NM: {
        label: "NM",
        value: 31,
      },
      US_NY: {
        label: "NY",
        value: 32,
      },
      US_NC: {
        label: "NC",
        value: 33,
      },
      US_ND: {
        label: "ND",
        value: 34,
      },
      US_OH: {
        label: "OH",
        value: 35,
      },
      US_OK: {
        label: "OK",
        value: 36,
      },
      US_OR: {
        label: "OR",
        value: 37,
      },
      US_PA: {
        label: "PA",
        value: 38,
      },
      US_RI: {
        label: "RI",
        value: 39,
      },
      US_SC: {
        label: "SC",
        value: 40,
      },
      US_SD: {
        label: "SD",
        value: 41,
      },
      US_TN: {
        label: "TN",
        value: 42,
      },
      US_TX: {
        label: "TX",
        value: 43,
      },
      US_UT: {
        label: "UT",
        value: 44,
      },
      US_VT: {
        label: "VT",
        value: 45,
      },
      US_VA: {
        label: "VA",
        value: 46,
      },
      US_WA: {
        label: "WA",
        value: 47,
      },
      US_WV: {
        label: "WV",
        value: 48,
      },
      US_WI: {
        label: "WI",
        value: 49,
      },
      US_WY: {
        label: "WY",
        value: 50,
      },
    },
  },
  cn: {
    label: "Canada",
    values: {
      CN_AB: {
        label: "AB",
        value: 51,
      },
      CN_BC: {
        label: "BC",
        value: 52,
      },
      CN_MB: {
        label: "MB",
        value: 53,
      },
      CN_NB: {
        label: "NB",
        value: 54,
      },
      CN_NL: {
        label: "NL",
        value: 55,
      },
      CN_NT: {
        label: "NT",
        value: 56,
      },
      CN_NS: {
        label: "NS",
        value: 57,
      },
      CN_NU: {
        label: "NU",
        value: 58,
      },
      CN_ON: {
        label: "ON",
        value: 59,
      },
      CN_PE: {
        label: "PE",
        value: 60,
      },
      CN_QC: {
        label: "QC",
        value: 61,
      },
      CN_SK: {
        label: "SK",
        value: 62,
      },
      CN_YT: {
        label: "YT",
        value: 63,
      },
    },
  },
};

export const modalType = {
  login: "login",
  register: "register",
  recoverPassword: "recoverPassword",
  changePassword: "changePassword",
  accountConfirmation: "accountConfirmation",
  learnMore: "learnMore",
  symptomReportForm: "symptomReportForm",
  symptomReportSuccess: "symptomReportSuccess",
  signupWizzard: "signupWizzard",
  accountConfirmationEmail: "accountConfirmationEmail",
  adminRegistrationProcess: "adminRegistrationProcess",
  inviteAdmin: "inviteAdmin",
  avoidModalClose: "avoidModalClose",
  notice: "notice",
  loggedOut: "loggedOut",
  eligibility: "eligibility",
};

export const roles = {
  participant: "Participant",
  itAdmin: "IT Admin",
  studyAdmin: "Study Admin",
  contentAdmin: "Content Admin",
};

export const profiles = {
  none: "none",
  participant: "Participant",
  executive: "Executive",
  itAdmin: "IT Admin",
  studyAdmin: "Study Admin",
  contentAdmin: "Content Admin",
  dietitian: "Dietitian",
  siteCoordinator: "Site Coordinator",
  pi: "Principal Investigator",
  siteMonitor: "Site Monitor",
  sponsor: "Sponsor",
  medicalMonitor: "Medical Monitor",
  dataManager: "Data Manager",
};

export const studiesIds = {
  gsdiii: "B6A48F33-5587-48BF-A980-4A8C3C8A87AB",
  lcfaod402: "0cb8b27f-2f29-42ad-b56b-556f3253fb3a",
  xlh: "77C39769-F52C-4F0E-A6E3-E322AF36870D",
  lcfaod401: "3A9097F8-71EF-4C1E-8E74-E148EAABFAD1",
  beyondxlh402: "CFDB6B20-6E57-4D85-981C-C4C0DFB164E3",
};

export const studies = {
  none: "none",
  lcfaod402: "LC-FAOD 402",
  xlh: "XLH",
  gsdiii: "GSDIII",
  lcfaod401: "LC-FAOD 401",
  beyondxlh402: "BXLH",
};

export const sidebarStatus = {
  hidden: "hidden",
  collapsed: "collapsed",
  expanded: "expanded",
};

//Need to add this line to avoid warnings with the regex escaping character
/* eslint-disable */
export const regex = new RegExp(
  "^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[\\[\\]!@#$%^&*^~+=`|\\(){}:;'<>,.?/\"_-]).{12,16}$"
);

export const nameRegex = new RegExp("\\d");

const emailRegexSTR =
  "[_a-zA-Z0-9-]+(\\.[_a-zA-Z0-9-]+)*(\\+[_a-zA-Z0-9-]+)?@[a-zA-Z0-9](([\\w\\-]*)[a-zA-Z0-9])*(\\.[a-zA-Z0-9](([\\w\\-]*)[a-zA-Z0-9])*)+";

export const emailRegex = new RegExp("^" + emailRegexSTR + "$");

export const phoneRegex = new RegExp(
  "^(9[976]|8[987530]|6[987]|5[90]|42|3[875]|2[98654321]|9[8543210]|8[6421]|6[6543210]|5[87654321]|4[987654310]|3[9643210]|2[70]|7|1){1,14}$"
);

// participant id or email
export const loginRegex = new RegExp("^\\d{3}-\\d{3}$|^" + emailRegexSTR + "$");

// rarify id or email
export const loginRegex402 = new RegExp(
  "^\\w{3}-\\w{2}-\\w{3}$|^" + emailRegexSTR + "$"
);

// rarify id
export const rarifyIdRegex = new RegExp(
  "^[a-zA-Z0-9]{3}-[a-zA-Z0-9]{2}-[a-zA-Z0-9]{3}$"
);

// thread id
export const threadIdRegex = new RegExp(
  "^[a-z0-9]{8}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{12}$"
);

// allow commas and dots
export const decimalRegex = new RegExp("^(?:\\d+)?(?:[\\,\\.](?:\\d+)?)?$");

export const tokenStatus = {
  valid: 1,
  invalid: 2,
};

export const tokenType = {
  registration: 1,
  password: 2,
  adminInvitation: 3,
};

export const FieldsValidation = {
  email: {
    size: 128,
    localPart: 64,
  },
  phone: {
    size: 20,
    minSize: 5,
  },
};

export const studyStatusesGSDIII = {
  SAD_PERIOD: {
    id: 1,
    value: "SAD Period",
  },
  RD_ISV: {
    id: 2,
    value: "RD: ISV",
  },
  RD_NOV: {
    id: 3,
    value: "RD: NOV",
  },
  RD_STV: {
    id: 4,
    value: "RD: STV",
  },
  RD_TRATMENT: {
    id: 5,
    value: "RD: Treatment",
  },
  SCREEN_FAIL: {
    id: 6,
    value: "Screen Fail",
  },
  EARLY_TERMINATION: {
    id: 7,
    value: "Early Termination",
  },
  COMPLETE: {
    id: 8,
    value: "Complete",
  },
};

export const studyStatusesFAOD = {
  ACTIVE_DMP: {
    id: 101,
    value: "Active",
  },
  EARLY_TERMINATION: {
    id: 102,
    value: "Early Termination",
  },
  COMPLETE: {
    id: 103,
    value: "Complete",
  },
};

export const studyStatusesFAOD402 = {
  UNVERIFIED: {
    id: 201,
    value: "Unverified",
  },
  EMAIL_VERIFIED: {
    id: 202,
    value: "E-mail Verified",
  },
  ACTIVE: {
    id: 203,
    value: "Active",
  },
  WITHDRAWN: {
    id: 204,
    value: "Withdrawn",
  },
  COMPLETE: {
    id: 205,
    value: "Complete",
  },
};

export const studyStatusesBeyondXLH402 = {
  ACTIVE: {
    id: 301,
    value: "Active",
  },
  WITHDRAWN: {
    id: 302,
    value: "Withdrawn",
  },
  COMPLETED: {
    id: 303,
    value: "Completed",
  },
};

export const enrollmentStatus = {
  SADPeriod: 1,
  RD_ISV: 2,
  RD_NOV: 3,
  RD_STV: 4,
  RD_Treatment: 5,
  ScreenFail: 6,
  EarlyTermination: 7,
  Complete: 8,
};

export const unauthorizedStudyStatus = {
  gsdiii: [
    studyStatusesGSDIII.SCREEN_FAIL,
    studyStatusesGSDIII.EARLY_TERMINATION,
    studyStatusesGSDIII.COMPLETE,
  ],
  lcfaod402: [studyStatusesFAOD402.WITHDRAWN, studyStatusesFAOD402.COMPLETE],
  beyondxlh402: [
    studyStatusesBeyondXLH402.WITHDRAWN,
    studyStatusesBeyondXLH402.COMPLETED,
  ],
  lcfaod401: [studyStatusesFAOD.EARLY_TERMINATION, studyStatusesFAOD.COMPLETE],
};

export const urlStudies = {
  lcfaod402: "UX007-CL402",
  gsdiii: "UX053-CL101",
  lcfaod401: "UX007-CL401",
  beyondxlh402: "UX023-CL402",
};

export const modalHeaders = {
  login: "Login",
  register: "Set Up Account",
  loggedOut: "You’re now logged out",
  cookieConsent: "Cookie Settings",
  eligibility: "Eligibility Criteria Survey",
};

export const authErrors = {
  invalidPassword:
    "Passwords must have at least 12 characters, a max of 16 characters and contain the following: uppercase letters, lowercase letters, numbers, and symbols." +
    "The following symbols are accepted ~!@#$%^&*_-+=`|(){}[]:;\"'<>,.?/",
  noMatch: "Passwords do not match",
  invalidName: "Name cannot contain numbers",
  emailsNoMatch: "Email addresses do not match",
  invalidEmail: "Please enter a valid email",
};

export const modalMessages = {
  changePassword: "Your password was successfully changed.",
  adminRegistration: "Name and password set successfully. Please login.",
  accountConfirmation: "Your account has been confirmed.",
  expiredLink: "The link has expired.",
};

export const modalSubtitles = {
  doubleSession:
    "You have accessed your account from another device. Please log in again in this browser.",
};

export const FoodType = {
  COMMON: "common",
  BRANDED: "branded",
  CUSTOM: "custom",
};

export const dailyTargetIds = {
  CALORIES_ATTR_ID: 208,
  CARBS_ATTR_ID: 205,
  SUGAR_ATTR_ID: 269,
  FATS_ATTR_ID: 204,
  PROTEIN_ATTR_ID: 203,
};

export const PIE_CHART_SERIES_ATTRS = [
  dailyTargetIds.CARBS_ATTR_ID,
  dailyTargetIds.FATS_ATTR_ID,
  dailyTargetIds.PROTEIN_ATTR_ID,
];

export const MACRONUTRIENTS_401_ATTRS = {
  FATS_ATTR_ID: 204,
  LONG_CHAIN_FATS_ATTR_ID: -901, // custom attribute id, defined by Rarify BE
  MEDIUM_CHAIN_FATS_ATTR_ID: -900, // custom attribute id, defined by Rarify BE
};

export const getMacronutrientColor = (attr_id, theme, studyId = null) => {
  switch (attr_id) {
    case dailyTargetIds.CARBS_ATTR_ID:
      return studyId.toLocaleLowerCase() ===
        studiesIds.gsdiii.toLocaleLowerCase()
        ? theme?.magentaPink
        : theme?.aquamarine;
    case dailyTargetIds.FATS_ATTR_ID:
      return studyId.toLocaleLowerCase() ===
        studiesIds.lcfaod401.toLocaleLowerCase()
        ? theme?.blueMagenta
        : theme?.aquamarine;
    case dailyTargetIds.PROTEIN_ATTR_ID:
      return studyId.toLocaleLowerCase() ===
        studiesIds.gsdiii.toLocaleLowerCase()
        ? theme?.blueMagenta
        : theme?.magentaPink;
    default:
      return theme?.c7Silver;
  }
};

export const getTargetsBgColor = (attr_id, theme, studyId = null) => {
  switch (attr_id) {
    case dailyTargetIds.CARBS_ATTR_ID:
      return studyId.toLocaleLowerCase() ===
        studiesIds.gsdiii.toLocaleLowerCase()
        ? theme?.pinkityDrinkity
        : theme?.vantaTeal;
    case dailyTargetIds.PROTEIN_ATTR_ID:
      return studyId.toLocaleLowerCase() ===
        studiesIds.gsdiii.toLocaleLowerCase()
        ? theme?.lightShadeBlueMagenta
        : theme?.pinkityDrinkity;
    default:
      return theme?.soulDance;
  }
};

export const Sites = {
  ALL: {
    id: null,
    value: "All",
  },
};

export const NotificationType = {
  EMAIL: 1,
  PHONE: 2,
};

export const DateFormat = {
  BASE_FORMAT: "DD/MMM/yyyy",
  EXTENDED_FORMAT: "dddd DD/MMM/yyyy",
  EXTENDED_FORMAT_WITH_HOUR: "dd/MMM/yyyy h:mm aa",
  INVERTED_DATE: "YYYY-MM-DD",
  START_DATE: "YYYY-MM-DDT00:00:00",
  END_DATE: "YYYY-MM-DDT23:59:59",
  YEAR: "YYYY",
  MONTH: "MMMM",
  YEAR_LOWER: "yyyy",
  MONTH_NUMBER: "M",
  EXTENDED_DATETIME: "YYYY-MM-DDTHH:mm",
};

export const TimeZone = {
  PST: "America/Los_Angeles",
};

export const reportTypes = {
  PDF: {
    id: 1,
    value: "PDF, Verification of Nutrition Stabilization",
  },
  CSV_DAILY_AVERAGES: {
    id: 2,
    value: "CSV, Daily Averages",
  },
  CSV_24H_RECALL: {
    id: 3,
    value: "CSV, 24h Recall",
  },
};

export const ChangeRequestStatus = {
  ALL: {
    id: null,
    value: "All",
  },
  OPEN: {
    id: 1,
    value: "Open",
  },
  APPROVED: {
    id: 2,
    value: "Approved",
  },
  DECLINED: {
    id: 3,
    value: "Declined",
  },
};

export const SurveyStatus = {
  ALL: {
    id: null,
    value: "All",
  },
  COMPLETED: {
    id: 1,
    value: "Completed",
  },
  TO_DO: {
    id: 2,
    value: "To Do",
  },
  EXPIRED: {
    id: 3,
    value: "Expired",
  },
};

export const USER_GUIDES_BASE_URL =
  process.env.REACT_APP_USER_GUIDES_BASE_URL ||
  "https://rarify-assets.s3.us-east-2.amazonaws.com/userguides/";

export const kcalMultiplier = {
  carbs: 4,
  protein: 4,
  fats: 9,
};

export const SurveyType = {
  CLINICAL_SURVEY: {
    value: "clinical-survey",
  },
  PII_SURVEY: {
    value: "pii-survey",
  },
};

export const NextStepTypes = {
  BIRTHDATE: "birthdate",
  CONSENT: "consent",
  CHILD_ASSENT: "child",
  ADOLSCENT_ASSENT: "adolescent",
  ADVERSE_EVENT: "adverse",
};

export const SurveyThemes = {
  RARIFY: "RARIFY",
  EQ5D5L: "EQ-5D-5L",
};

export const SurveyParams = {
  title: "title",
  model: "model",
};

export const dashboardType = {
  participant: "participantDashboard",
  survey: "surveyDashboard",
};

export const timeConvert = {
  dayToMinutes: 1440,
  hourToMinutes: 60,
};

export const noDateDefinedOrEmpty = "0001-01-01T00:00:00";

export const RecoverPasswordType = {
  resetPassword: 0,
  forgotPassword: 1,
};
